import React, { useEffect, useState } from "react";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  sidebarClasses,
} from "react-pro-sidebar";
import {
  FaAlignJustify,
  FaUsers,
  FaUserTie,
  FaIndustry,
  FaToggleOn,
  FaToggleOff,
} from "react-icons/fa";
import { FaChartSimple } from "react-icons/fa6";
import { BsDatabaseFillAdd } from "react-icons/bs";
import { AiOutlineAreaChart, AiOutlineAudit } from "react-icons/ai";

import { MdAccountCircle } from "react-icons/md";
import "../ComponentsCSS/Sidebar.css";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import skyline from "./skyline.png";
import "../ComponentsCSS/Sidebar1.css";


const SideBar1 = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [collapse, setCollapse] = useState(false);
  const [display, setDisplay] = useState("");
  const [breakPoint, setBreakPoint] = useState(false);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserData(userData);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      setWidth(windowWidth);
      console.log(windowWidth);
      if (windowWidth < 600) {
        setCollapse(true);
        setDisplay("");
        setBreakPoint(true);
      } else {
        setCollapse(false);
        setDisplay("display");
        setBreakPoint(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleCollapse = () => {
    setCollapse(!collapse);
    setBreakPoint(!collapse);
  };

  return (
    <div className="sidebar">

      <Sidebar
        collapsed={collapse}
        rootStyles={{
          [`.${sidebarClasses.container}`]: {
            backgroundColor: "#a2abe3",
            height: "100vh",
            paddingTop: "40px",
            position: "relative",
            bottom: "65px",
          },
        }}
      >
        <Menu
          menuItemStyles={{
            button: ({ level, disabled }) => ({
              color: disabled ? "white" : "white",
              "&:hover": {
                backgroundColor: "#8a8dc5",
              },
            }),
          }}
        >

       {/* Conditional rendering of the logo */}
       {!collapse && (
            <>
              <Box
                component="img"
                className="logo1"
                alt="Your logo."
                src={skyline}
              />
       
            </>
          )}

          <h3 className="Admin">{userData.username}</h3>

            {/* ............ Start of the sidebar fields........................ */}
          <Link to="/Dashboard1">
            <MenuItem icon={<FaChartSimple />}> DashBoard </MenuItem>
          </Link>


          {/* <Link to="/dsr">
              <MenuItem icon={<BsDatabaseFillAdd />}>  Members Data</MenuItem>
            </Link> */}


          <SubMenu icon={<FaUsers />} className="Sub-Menu" label="Students Data">
        
            <Link to="/StudentData1">
              <MenuItem icon={<FaUserTie />}> Add Members </MenuItem>
            </Link>
            
              <Link to="/ManageMembers1">
                <MenuItem icon={<BsDatabaseFillAdd />}> Manage Members </MenuItem>
              </Link>
          </SubMenu>

          <Link to="/Attendance1">
                <MenuItem icon={<AiOutlineAudit />}> Attendance </MenuItem>
              </Link>
          {/* <SubMenu  className="Sub-Menu"  icon={<AiOutlineAreaChart />}  label="Reports"
          >
            <Link to="/dsrTable">
              <MenuItem icon={<BsDatabaseFillAdd />}> Manage DSR </MenuItem>
            </Link>
          </SubMenu> */}

          <Link to="/Report1">
                <MenuItem icon={<AiOutlineAreaChart />}> Reports </MenuItem>
          </Link>


          {/* <SubMenu
            className="Sub-Menu"
            icon={<MdOutlineCrisisAlert />}
            label="Sales"
          >
            <Link to="/">
              <MenuItem icon={<GoProjectSymlink />}> Projects </MenuItem>
            </Link>
            <MenuItem icon={<FaIndustry />}> Company </MenuItem>
          </SubMenu> */}




          <SubMenu icon={<FaUsers />} className="Sub-Menu" label="Employees">
              <Link to="/Users1">
                    <MenuItem icon={<MdAccountCircle />}> Add Employees </MenuItem>
              </Link>
            
              <Link to="/ManageEmployees1">
                <MenuItem icon={<BsDatabaseFillAdd />}> Manage Employees </MenuItem>
              </Link>
          </SubMenu>

          
        <SubMenu icon={<FaUsers />} className="Sub-Menu" label="Packages">
              <Link to="/Packages1">
                    <MenuItem icon={<MdAccountCircle />}> Add Packages </MenuItem>
              </Link>
            
              <Link to="/ManagePackage1">
                <MenuItem icon={<BsDatabaseFillAdd />}> Manage Packages </MenuItem>
              </Link>
          </SubMenu>

          </Menu>
        </Sidebar>



        






      {/* <div
        className={`toggle-button ${display ? "" : "hidden"}`}
        onClick={toggleCollapse}
      >
        {collapse ? (
          <FaToggleOn className="toggle-icon" />
        ) : (
          <FaToggleOff className="toggle-icon" />
        )}
      </div> */}
      <div
        className={`toggle-button ${display ? "" : "hidden"}`}
        onClick={toggleCollapse}
      >
        {collapse ? <FaToggleOn className="toggle-icon" /> : <FaToggleOff className="toggle-icon" />}
      </div>

      
    </div>
  );
};

export default SideBar1;
